// @ts-nocheck

import styled from 'styled-components';

import { SectionTitle as Title } from '../../../../components/layout';

export const SectionTitle = styled(Title).withConfig({ displayName: "GroupModalelements__SectionTitle", componentId: "sc-i9ocd7-0" })([".section__header{padding:13px 0;}"]);
